import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import { canWriteAccountingSettings, canWriteStammdaten } from "@/lib/permissions";
import { usePageHeader } from "@/layout/usePageHeader";
import { useBranding } from "@/lib/branding/useBranding";
import { StammdatenWriteHint } from "@/pages/stammdaten/StammdatenWriteHint";
import { InvoiceLetterheadSection } from "@/pages/stammdaten/InvoiceLetterheadSection";
import { OnlineBookingLegalSection } from "@/pages/stammdaten/OnlineBookingLegalSection";

export function GrundeinstellungenPage() {
  const { hash } = useLocation();
  const { setPageMeta } = usePageHeader();
  const { user } = useCurrentUser();
  const groups = useMemo(() => (user?.groups as string[] | undefined) ?? [], [user]);
  const canWriteAdmin = canWriteStammdaten(groups);
  const canWriteFinance = canWriteAccountingSettings(groups);
  const { reload: reloadBranding } = useBranding();

  useEffect(() => {
    setPageMeta({ title: "Stammdaten", subtitle: "Betriebsdaten" });
    return () => setPageMeta(null);
  }, [setPageMeta]);

  // Deep-Links aus der Stammdaten-Suche (z. B. #rechtliches) nach dem Seitenwechsel anspringen
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="space-y-6">
      {!canWriteFinance ? <StammdatenWriteHint /> : null}

      <InvoiceLetterheadSection canWrite={canWriteFinance} onSaved={reloadBranding} />
      <OnlineBookingLegalSection canWrite={canWriteAdmin} />
    </div>
  );
}
